/**
 * Mobile Viewport Height Hook
 * Handles mobile browser chrome and keyboard issues
 */
import { useState, useEffect } from 'react';

export function useMobileViewport() {
  const [viewportHeight, setViewportHeight] = useState(window.innerHeight);
  const [keyboardVisible, setKeyboardVisible] = useState(false);

  useEffect(() => {
    // Initial height
    const initialHeight = window.innerHeight;
    
    // Update viewport height
    const handleResize = () => {
      const currentHeight = window.innerHeight;
      setViewportHeight(currentHeight);
      
      // Detect virtual keyboard (height reduces by more than 100px)
      if (initialHeight - currentHeight > 100) {
        setKeyboardVisible(true);
      } else {
        setKeyboardVisible(false);
      }
    };

    // Visual viewport API for better mobile support
    if ('visualViewport' in window) {
      const viewport = window.visualViewport;
      viewport.addEventListener('resize', handleResize);
      viewport.addEventListener('scroll', handleResize);
      
      return () => {
        viewport.removeEventListener('resize', handleResize);
        viewport.removeEventListener('scroll', handleResize);
      };
    } else {
      // Fallback for older browsers
      window.addEventListener('resize', handleResize);
      window.addEventListener('orientationchange', handleResize);
      
      return () => {
        window.removeEventListener('resize', handleResize);
        window.removeEventListener('orientationchange', handleResize);
      };
    }
  }, []);

  return {
    viewportHeight,
    keyboardVisible,
    isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
  };
}

export default useMobileViewport;